import {
  Phone,
  Shield,
  Building2,
  HeartHandshake,
  Globe,
  CreditCard,
  AlertTriangle,
  Users,
} from "lucide-react";
import SEO from "@/components/SEO";

const sezioni = [
  {
    cat: "Emergenze e segnalazioni",
    subtitle: "Da chiamare subito in caso di truffa in corso o sospetta",
    palette: {
      block: "bg-[#FEE2E2] border-[#DC2626]",
      title: "text-[#7F1D1D]",
      iconBg: "bg-white",
      icon: "text-[#DC2626]",
      label: "text-[#7F1D1D]/80",
      num: "text-[#7F1D1D]",
      desc: "text-[#7F1D1D]/80",
      headerIcon: "text-[#DC2626]",
    },
    headerIcon: AlertTriangle,
    items: [
      {
        icon: Phone,
        label: "Numero unico emergenze",
        num: "112",
        desc: "Carabinieri, Polizia, Ambulanza — sempre attivo, 24 ore su 24",
      },
      {
        icon: Shield,
        label: "Polizia di Stato",
        num: "113",
        desc: "Ancora attivo in molte zone, collegato al Numero Unico Europeo",
      },
      {
        icon: Shield,
        label: "Guardia di Finanza",
        num: "117",
        desc: "Per frodi economiche e truffe finanziarie",
      },
    ],
  },
  {
    cat: "Truffe online e telefoniche",
    subtitle: "Per segnalare phishing, SMS truffa, WhatsApp falsi, finti operatori",
    palette: {
      block: "bg-[#DBEAFE] border-[#1E3A8A]",
      title: "text-[#1E3A8A]",
      iconBg: "bg-white",
      icon: "text-[#1E3A8A]",
      label: "text-[#1E3A8A]/80",
      num: "text-[#1E3A8A]",
      desc: "text-[#1E3A8A]/80",
      headerIcon: "text-[#1E3A8A]",
    },
    headerIcon: Shield,
    items: [
      {
        icon: Globe,
        label: "Commissariato di P.S. Online",
        num: "commissariatodips.it",
        desc: "Sito ufficiale della Polizia Postale per segnalare SMS, WhatsApp e email truffa, phishing, finti operatori della banca, truffe online",
        isLink: true,
        link: "https://www.commissariatodips.it",
      },
      {
        icon: Phone,
        label: "Centralino Polizia di Stato",
        num: "06 46541",
        desc: "Numero reale della Polizia di Stato",
      },
    ],
  },
  {
    cat: "Carte, Poste e banca",
    subtitle: "Per bloccare subito carte e segnalare movimenti sospetti",
    palette: {
      block: "bg-[#FEF3C7] border-[#D97706]",
      title: "text-[#78350F]",
      iconBg: "bg-white",
      icon: "text-[#D97706]",
      label: "text-[#78350F]/80",
      num: "text-[#78350F]",
      desc: "text-[#78350F]/80",
      headerIcon: "text-[#D97706]",
    },
    headerIcon: CreditCard,
    items: [
      {
        icon: Building2,
        label: "Poste Italiane antifrode",
        num: "800 003 322",
        desc: "Per blocco carte e segnalazioni sospette Poste / Postepay",
      },
      {
        icon: CreditCard,
        label: "Blocco carte internazionale",
        num: "800 822056",
        desc: "Servizio usato da molte banche per il blocco immediato delle carte",
      },
    ],
  },
  {
    cat: "Supporto umano per anziani soli o spaventati",
    subtitle: "Ascolto, compagnia e aiuto: non sei solo",
    palette: {
      block: "bg-[#DCFCE7] border-[#22C55E]",
      title: "text-[#14532D]",
      iconBg: "bg-white",
      icon: "text-[#16A34A]",
      label: "text-[#14532D]/80",
      num: "text-[#14532D]",
      desc: "text-[#14532D]/80",
      headerIcon: "text-[#16A34A]",
    },
    headerIcon: HeartHandshake,
    items: [
      {
        icon: HeartHandshake,
        label: "Telefono Amico Italia",
        num: "02 2327 2327",
        desc: "Ascolto e supporto emotivo. Non è specifico anti-truffa, ma è molto utile se ti senti solo o spaventato",
        web: "telefonoamico.it",
        webLink: "https://www.telefonoamico.it",
      },
      {
        icon: Users,
        label: "Auser Filo d'Argento",
        num: "800 995 988",
        desc: "Assistenza e compagnia per anziani, molto conosciuto in tutta Italia",
        web: "auser.it",
        webLink: "https://www.auser.it",
      },
    ],
  },
];

function isPhone(value) {
  return /^[0-9+\s]+$/.test(value);
}

export default function Numeri() {
  return (
    <div data-testid="numeri-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <SEO
        path="/numeri-utili"
        title="Numeri Utili anti-truffa: 112, Polizia Postale, Antifrode Poste"
        description="Tutti i numeri di telefono utili contro le truffe: 112 emergenze, 113 Polizia di Stato, 117 Guardia di Finanza, Commissariato online, Poste antifrode, Auser Filo d'Argento."
      />
      <div className="text-center mb-14 animate-fade-up">
        <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#1E3A8A] text-white text-base font-bold mb-5">
          <Phone size={20} /> Numeri Utili
        </span>
        <h1 className="font-heading text-4xl md:text-6xl font-extrabold text-[#1E3A8A] leading-tight">
          I numeri da tenere sempre vicino al telefono
        </h1>
        <p className="mt-5 text-xl md:text-2xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
          Stampa questa pagina e tienila in cucina o vicino al telefono.
          In caso di dubbio o emergenza, sai chi chiamare.
        </p>
      </div>

      <div className="space-y-10">
        {sezioni.map((sezione, sIdx) => {
          const HeaderIcon = sezione.headerIcon;
          const p = sezione.palette;
          return (
            <section
              key={sezione.cat}
              data-testid={`numeri-sezione-${sIdx}`}
              className={`${p.block} border-4 rounded-[2rem] p-6 md:p-8`}
            >
              <div className="flex items-start gap-4 mb-6">
                <div className={`w-14 h-14 rounded-2xl ${p.iconBg} flex items-center justify-center ${p.headerIcon} flex-shrink-0 shadow-sm`}>
                  <HeaderIcon size={30} />
                </div>
                <div className="flex-1">
                  <h2 className={`font-heading text-2xl md:text-3xl font-extrabold ${p.title} leading-tight`}>
                    {sezione.cat}
                  </h2>
                  <p className={`text-base md:text-lg mt-1 ${p.desc}`}>
                    {sezione.subtitle}
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {sezione.items.map((n, i) => {
                  const Icon = n.icon;
                  const phoneHref = isPhone(n.num) ? `tel:${n.num.replace(/\s/g, "")}` : null;
                  const externalHref = n.isLink ? n.link : null;
                  const href = externalHref || phoneHref;
                  const Wrapper = href && !n.web ? "a" : "div";
                  return (
                    <Wrapper
                      key={`${sezione.cat}-${n.label}`}
                      href={Wrapper === "a" ? href : undefined}
                      target={Wrapper === "a" && externalHref ? "_blank" : undefined}
                      rel={Wrapper === "a" && externalHref ? "noopener noreferrer" : undefined}
                      data-testid={`numero-${sIdx}-${i}`}
                      className={`block bg-white rounded-3xl p-5 md:p-6 hover:shadow-xl transition-all ${href ? "cursor-pointer active:scale-[0.98]" : ""} border-2 border-white/40`}
                    >
                      <div className="flex items-start gap-4">
                        <div className={`w-14 h-14 rounded-2xl ${p.iconBg} ring-2 ring-current/10 flex items-center justify-center ${p.icon} flex-shrink-0`}>
                          <Icon size={28} />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className={`text-base font-semibold ${p.label}`}>
                            {n.label}
                          </div>
                          <div className={`font-heading text-2xl md:text-3xl font-extrabold mt-1 break-words ${p.num}`}>
                            {n.web && phoneHref ? (
                              <a href={phoneHref} data-testid={`numero-${sIdx}-${i}-tel`} className="hover:underline">
                                {n.num}
                              </a>
                            ) : (
                              n.num
                            )}
                          </div>
                          <div className={`text-base md:text-lg mt-2 leading-relaxed ${p.desc}`}>
                            {n.desc}
                          </div>
                          {n.web && (
                            <a
                              href={n.webLink}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => e.stopPropagation()}
                              data-testid={`numero-${sIdx}-${i}-web`}
                              className={`mt-3 inline-flex items-center gap-2 text-base font-semibold underline ${p.num}`}
                            >
                              <Globe size={18} /> {n.web}
                            </a>
                          )}
                        </div>
                      </div>
                    </Wrapper>
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>

      <div className="mt-14 bg-[#1E3A8A] text-white rounded-[2rem] p-8 md:p-12 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-extrabold mb-4">
          Nel dubbio, chiama un familiare di fiducia
        </h2>
        <p className="text-xl text-blue-100 leading-relaxed">
          Tieni sempre a portata di mano i numeri di un figlio, un nipote o un amico di cui ti fidi.
          Non c'è nulla di male nel chiedere consiglio: anzi, è la cosa più intelligente da fare.
        </p>
      </div>
    </div>
  );
}
